import React, { memo, useState } from 'react'
import * as Styled from './styled'

const AnimatedToggler = ({options, handleChange}) => {
  const getFirstSelectedSide = () => options.findIndex(o => !!o.selected) === 0 ? 'left' : 'right';
  const firstSelectedSide = getFirstSelectedSide();
  const [selectedSide, setSelectedSide] = useState(firstSelectedSide);

  const toggleSide = () => {
    const newSide = options[0].selected ? 'right' : 'left'
    setSelectedSide(newSide)
    const optionsAfterToggle = options.map(opt => ({ ...opt, selected: !opt.selected}))
    handleChange(optionsAfterToggle);
  }

  return (
    <Styled.Toggler onClick={toggleSide} className={'switch-button style-two ' + selectedSide}>
      <input className="left" type="radio" name="select-radio"  value={options[0].value} />
      <input className="right" type="radio" name="select-radio" value={options[0].value} />
      <button className="left">{options[0].label}</button>
      <div className="switch"></div>
      <button className="right">{options[1].label}</button>
    </Styled.Toggler>
  )
};

export default memo(AnimatedToggler)
